import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.jpg'
import waterColorImg from './img/water-color.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM'
      : 'VÃO SE CASAR'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro303">
      <div className="intro303mobile screen">
        <img
          className="main-background-oufZxx"
          src={background || backgroundImg}
        />
        <div className="mask-oufZxx"></div>
        <img className="watercolor-slim-oufZxx" src={waterColorImg} />
        <div className="container-center-horizontal">
          <div className="button-oufZxx">
            <div
              className="site-de-casamento-e-eGpBfx"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-eGpBfx" onClick={onSkipIntro}>
              <div className="button-Ktow2t"></div>
              <div className="pular-introduo-Ktow2t">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-oufZxx">
            <div className="e-T0XhvV bp2-intro303-animate-enter">
              {coupleSimplifiedName.groom}
            </div>
            <div className="m-T0XhvV bp2-intro303-animate-enter1">
              {coupleSimplifiedName.bride}
            </div>
            <div className="mariana-eduardo-T0XhvV bp2-intro303-animate-enter2">
              {text}
            </div>
          </div>
        </div>
      </div>
      <div className="intro303desktop screen">
        <img
          className="main-background-IS9kES bp1-intro303-animate-enter"
          src={background || backgroundImg}
        />
        <div className="mask-IS9kES"></div>
        <img className="watercolor-slim-IS9kES" src={waterColorImg} />
        <div className="container-center-horizontal">
          <div className="button-IS9kES">
            <div
              className="site-de-casamento-e-eGKh4t"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-eGKh4t" onClick={onSkipIntro}>
              <div className="button-So8euG"></div>
              <div className="pular-introduo-So8euG">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-IS9kES">
            <div className="e-HGd3RH bp1-intro303-animate-enter1">
              {coupleSimplifiedName.groom}
            </div>
            <div className="m-HGd3RH bp1-intro303-animate-enter2">
              {coupleSimplifiedName.bride}
            </div>
            <div className="mariana-eduardo-HGd3RH bp1-intro303-animate-enter3">
              {text}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
